import { graphql } from '~/resources/graphql'
import { useRpQuery } from '~/composables/graphql'

export type WindcavePurchaseSessionInputData = {
    type: 'WindcavePurchaseSessionInputData'
    checkoutId: string
    amount: string
    firstName: string
    lastName: string
    phone: string
    email: string
    postalCode: string
}

export type WindcaveTokenizeSessionInputData = {
    type: 'WindcaveTokenizeSessionInputData'
    firstName: string
    lastName: string
    phone: string
    email: string
    postalCode: string
}

export type WindcaveSessionInputData =
    | WindcavePurchaseSessionInputData
    | WindcaveTokenizeSessionInputData

export function useWindcaveQuery() {
    const rpQuery = useRpQuery()

    async function queryWindcaveSession(
        paymentSourceId: string,
        data: WindcaveSessionInputData
    ) {
        if (data.type === 'WindcavePurchaseSessionInputData') {
            const response = await rpQuery(
                graphql(/* GraphQL */ `
                    mutation CreateWindcavePurchaseSession(
                        $input: CreateWindcavePurchaseSessionInput!
                    ) {
                        createWindcavePurchaseSession(input: $input) {
                            url
                            supportedCards
                            sessionId
                        }
                    }
                `),
                {
                    input: {
                        ...data,
                        paymentSourceId,
                        // Wipe out type
                        type: undefined
                    }
                }
            )

            // The server-side checkout cache is authoritative for purchase sessions.
            return response.createWindcavePurchaseSession
        } else {
            const response = await rpQuery(
                graphql(/* GraphQL */ `
                    mutation CreateWindcaveTokenizeSession(
                        $input: CreateWindcaveTokenizeSessionInput!
                    ) {
                        createWindcaveTokenizeSession(input: $input) {
                            url
                            supportedCards
                            sessionId
                        }
                    }
                `),
                {
                    input: {
                        ...data,
                        paymentSourceId,
                        // Wipe out type
                        type: undefined
                    }
                }
            )

            // Saved-card sessions are explicitly created without requiring a checkout.
            return response.createWindcaveTokenizeSession
        }
    }

    return {
        queryWindcaveSession
    }
}
